export default "__VITE_ASSET__4d4617cf__"